import { PayloadAction } from '@reduxjs/toolkit';

import { EditorState } from 'editor/src/store/editor/types';

const setTextEditModeReducer = (state: EditorState, { payload: enable }: PayloadAction<boolean>) => {
  state.textEditMode = enable;
};

export default setTextEditModeReducer;
